import axios from "axios";
import { getToken } from "../components/Authentication/get-token";
import { BASE_URL } from "../strings";


/**
 * Axios instance with default configuration
 */
const api = axios.create({
  baseURL: BASE_URL, // default base URL
  headers: {
    "Content-Type": "application/json",
    Connection: "keep-alive",
    "Accept-Language": "en-US",
  },
});

/**
 * Request interceptor
 * Adds Authorization token to every request
 */
api.interceptors.request.use(
  async (config) => {
    const tokenConfig = await getToken();

    if (tokenConfig?.headers?.Authorization) {
      config.headers.Authorization = tokenConfig.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Common API request helper
 *
 * @param {Object} options
 * @param {String} options.method HTTP method
 * @param {String} options.endPoint API endpoint
 * @param {Object} options.data Request payload
 * @param {Object} options.params Query parameters
 * @param {Object} options.headers Additional headers
 * @param {String} options.baseURL Optional base URL to override default
 */
const apiRequest = async ({
  method = "GET",
  endPoint,
  data = null,
  params = null,
  headers = {},
  baseURL = null,
}) => {
  try {
    const response = await api.request({
      method,
      url:endPoint,
      data,
      params,
      headers,
      baseURL: baseURL || BASE_URL,
    });

    return response.data;
  } catch (error) {
    console.error("API request failed", {
      method,
      endPoint,
      baseURL,
      error,
    });
    throw error;
  }
};

export default apiRequest;
